module.exports = __webpack_public_path__ + "components/country-flag/static/sd-0cdf90b2e61ee8c9b17df5e75dc71c80.svg";